import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { fetchDdGuardState } from '../services/api'

const PREFIX = '[useDrawdownGuard]'

// Poll the portfolio-gate state on an interval. Shared by any view that needs to
// reflect the gate (banner, status badge, disabling manual entry controls).
// Fail-soft: a failed poll leaves the last known state in place.
export function useDrawdownGuard(pollMs = 30000) {
  const guard = ref(null)
  let timer = null

  async function refresh() {
    try {
      guard.value = await fetchDdGuardState()
    } catch (err) {
      console.warn(`${PREFIX} failed to fetch portfolio-gate state:`, err?.message || err)
    }
  }

  // Render nothing at all when the gate is disabled.
  const enabled = computed(() => !!guard.value?.enabled)
  const triggered = computed(() => enabled.value && !!guard.value?.triggered)

  // 'off' | 'ok' | 'profit' | 'loss' — drives the status badge colour.
  const status = computed(() => {
    if (!enabled.value) return 'off'
    if (triggered.value) {
      return guard.value?.reason === 'LOSS_STOP' ? 'loss' : 'profit'
    }
    return 'ok'
  })

  onMounted(() => {
    refresh()
    timer = setInterval(refresh, pollMs)
  })
  onBeforeUnmount(() => {
    if (timer) clearInterval(timer)
  })

  return { guard, enabled, triggered, status, refresh }
}
